var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isAppReady
    ? _c(
        "div",
        { attrs: { id: "app" } },
        [
          !_vm.isMaintenancePage ? _c("adam-header") : _vm._e(),
          _vm.hasAppReadAccess && !_vm.isMaintenancePage
            ? _c(
                "div",
                [
                  _c("navigation-bar"),
                  _c(
                    "div",
                    {
                      staticClass: "pt-4 overflow-y-auto",
                      staticStyle: { height: "calc(100vh - 9.6rem)" }
                    },
                    [_c("router-view")],
                    1
                  )
                ],
                1
              )
            : !_vm.isMaintenancePage
            ? _c("Forbidden")
            : _c("router-view")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }